import React, { useState, useEffect } from "react";
import api from "../utils/axiosConfig";
import localforage from "localforage";
import "../css/welcomeWidgets.css";

const API_URL = process.env.REACT_APP_API_URL;


const WelcomeWidgets = () => {
  const [now, setNow] = useState(new Date());
  const [momStats, setMomStats] = useState({ totalMoms: 0, momsThisMonth: 0, byState: {} });
  const [cabStats, setCabStats] = useState({ pending: 0, approved: 0, byState: {} });

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const token = await localforage.getItem("token");
        const headers = { Authorization: `Bearer ${token}` };
        const [m, c] = await Promise.allSettled([
          api.get(`${API_URL}/mom-format/stats`, { headers }),
          api.get(`${API_URL}/cab/stats`, { headers }),
        ]);
        if (m.status === "fulfilled" && m.value.data) setMomStats(m.value.data);
        if (c.status === "fulfilled" && c.value.data) setCabStats(c.value.data);
      } catch (e) {
        /* best-effort */
      }
    })();
  }, []);


  const hh = now.getHours();
  const hour12 = hh % 12 || 12;
  const pad = (n) => String(n).padStart(2, "0");
  const ampm = hh >= 12 ? "PM" : "AM";

  // Approved cab requests split by state (backend /cab/stats -> byState).
  // Falls back to 0 so the chips still render on older API responses.
  const cabByState = cabStats.byState || {};
  const apApproved = (cabByState["Andhra Pradesh"] || {}).approved || 0;
  const pjApproved = (cabByState["Punjab"] || {}).approved || 0;

  const cabTotal = cabStats.total || 0;
  const cabPending = cabStats.pending || 0;

  const momByState = momStats.byState || {};
  const apMom = momByState["Andhra Pradesh"] || {};
  const pjMom = momByState["Punjab"] || {};
  const apMoms = apMom.total || 0;
  const pjMoms = pjMom.total || 0;
  const apMomsMonth = apMom.thisMonth || 0;
  const pjMomsMonth = pjMom.thisMonth || 0;

  return (
    <div className="ww-rail">
      {/* Clock */}
      <div className="ww-clock">
        <div className="ww-clock-time">
          {pad(hour12)}
          <span className="ww-colon">:</span>
          {pad(now.getMinutes())}
          <span className="ww-colon">:</span>
          {pad(now.getSeconds())}
          <span className="ww-ampm">{ampm}</span>
        </div>
        <div className="ww-clock-date">
          {now.toLocaleDateString("en-IN", {
            weekday: "long",
            day: "numeric",
            month: "long",
            year: "numeric",
          })}
        </div>
      </div>


      {/* MoM numbers in a single card (mirrors the cab card below). */}
      <div className="ww-cabcard ww-momcard">
        <div className="ww-cabcard-head">
          <span aria-hidden="true">📋</span>
          <span className="ww-cabcard-title">MoMs</span>
        </div>
        <div className="ww-cabcard-total">
          <span className="v">{momStats.totalMoms || 0}</span>
          <span className="l">Total MoMs · all states</span>
        </div>
        <div className="ww-cabcard-grid ww-grid-2">
          <div className="ww-cabcard-item is-ap">
            <div className="v">{apMoms}</div>
            <div className="l">AP · Total</div>
          </div>
          <div className="ww-cabcard-item is-pb">
            <div className="v">{pjMoms}</div>
            <div className="l">Punjab · Total</div>
          </div>
          <div className="ww-cabcard-item is-ap">
            <div className="v">{apMomsMonth}</div>
            <div className="l">AP · This Month</div>
          </div>
          <div className="ww-cabcard-item is-pb">
            <div className="v">{pjMomsMonth}</div>
            <div className="l">Punjab · This Month</div>
          </div>
        </div>
      </div>

      {/* All cab numbers in a single card. Styles are inlined here so this
          renders correctly without touching welcomeWidgets.css. */}
      <style>{`
        .ww-cabcard {
          background: #fff;
          border-radius: 14px;
          padding: 14px 16px 12px;
          box-shadow: 0 6px 18px rgba(16, 42, 76, 0.08);
          border-left: 4px solid #2f8f4e;
          margin-top: 12px;
        }
        .ww-cabcard-head {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 10px;
        }
        .ww-cabcard-title {
          font-size: 13px;
          font-weight: 700;
          color: #102a4c;
          letter-spacing: .2px;
        }
        .ww-cabcard-total {
          display: flex;
          align-items: baseline;
          gap: 8px;
          padding-bottom: 10px;
          border-bottom: 1px solid #eef2f7;
          margin-bottom: 10px;
        }
        .ww-cabcard-total .v {
          font-size: 30px;
          font-weight: 800;
          color: #102a4c;
          line-height: 1;
        }
        .ww-cabcard-total .l {
          font-size: 12px;
          color: #6a7c93;
          font-weight: 600;
        }
        .ww-cabcard-grid {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 8px;
        }
        .ww-cabcard-item {
          background: #f7f9fc;
          border-radius: 10px;
          padding: 8px 6px;
          text-align: center;
        }
        .ww-cabcard-item .v {
          font-size: 18px;
          font-weight: 800;
          line-height: 1.1;
        }
        .ww-cabcard-item .l {
          font-size: 10.5px;
          color: #6a7c93;
          font-weight: 600;
          margin-top: 2px;
          line-height: 1.25;
        }
        .ww-momcard { border-left-color: #1f6fd0; margin-top: 0; }
        .ww-cabcard-grid.ww-grid-2 {
          grid-template-columns: repeat(2, minmax(0, 1fr));
        }
        .ww-cabcard-item.is-month .v { color: #1f6fd0; }
        .ww-cabcard-item.is-pending .v { color: #d08700; }
        .ww-cabcard-item.is-ap .v { color: #2f8f4e; }
        .ww-cabcard-item.is-pb .v { color: #2f8f4e; }
      `}</style>
      <div className="ww-cabcard">
        <div className="ww-cabcard-head">
          <span aria-hidden="true">🚕</span>
          <span className="ww-cabcard-title">Cab Requests</span>
        </div>
        <div className="ww-cabcard-total">
          <span className="v">{cabTotal}</span>
          <span className="l">Total Requests</span>
        </div>
        <div className="ww-cabcard-grid">
          <div className="ww-cabcard-item is-pending">
            <div className="v">{cabPending}</div>
            <div className="l">Pending</div>
          </div>
          <div className="ww-cabcard-item is-ap">
            <div className="v">{apApproved}</div>
            <div className="l">Approved AP</div>
          </div>
          <div className="ww-cabcard-item is-pb">
            <div className="v">{pjApproved}</div>
            <div className="l">Approved Punjab</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeWidgets;
